var path = 'app/scripts/modules/kubernetes/src/v2/pipelines/stages/findArtifactsFromResource/findArtifactsFromResourceConfig.html';
var html = "<div class=\"form-horizontal\">\n  <div class=\"alert alert-warning\">\n    <strong>Warning!</strong> This stage is under active development and is subject to change.\n  </div>\n\n  <h4>Manifest</h4>\n  <div class=\"horizontal-rule\"></div>\n  <kubernetes-manifest-selector selector=\"ctrl.$scope.stage\"></kubernetes-manifest-selector>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/kubernetes/src/v2/pipelines/stages/findArtifactsFromResource/findArtifactsFromResourceConfig.html
// module id = 1534
// module chunks = 0